import {
  DEFAULT_OPTIONS_LIMIT,
  SEARCH_OPTIONS_LIMIT,
  filterTypeheadOptions
} from "../utilities/typehead-search.js";

/**
 * Search behaviour for a component with a single typeahead multiselect.
 *
 * The component should:
 * - define a `typeheadOptions` computed returning its full options list
 * - optionally override `limitTypehead()` to size the dropdown when nothing
 *   was typed yet (used to show the doctor's whole history)
 * - bind the multiselect to `filteredTypeheadOptions` with
 *   `:internal-search="false"`, `:options-limit="limit"`,
 *   `@search-change="onSearch"` and `@close="onSearch('')"`
 */
export default {
  data() {
    return {
      // Text typed in the multiselect, filtering is done by the component
      searchQuery: "",
      // Typeahead dropdown limit
      limit: DEFAULT_OPTIONS_LIMIT
    };
  },
  computed: {
    /** Overridden by the component with its own options list */
    typeheadOptions() {
      return [];
    },

    /** Options matching the search, ordered by relevance */
    filteredTypeheadOptions() {
      return filterTypeheadOptions(this.typeheadOptions, this.searchQuery);
    }
  },
  methods: {
    /**
     * Number of options to show when no search was typed,
     * overridden by components that show the doctor's history
     */
    limitTypehead() {
      return DEFAULT_OPTIONS_LIMIT;
    },

    onSearch(searchValue) {
      this.searchQuery = searchValue || "";
      this.limit = this.searchQuery.trim()
        ? SEARCH_OPTIONS_LIMIT
        : this.limitTypehead();
    }
  }
};
